import { ApiError, api } from '../../lib/api.js';
import { el } from '../../lib/dom.js';
import { speichernJetzt } from '../../lib/state.js';
import { fotoRow } from './fotos.js';
import { druckeProtokoll } from './print.js';
import { sigPad } from './sigpad.js';
import type { WizardCtx } from './types.js';

export function renderAbschluss(ctx: WizardCtx, container: HTMLElement): void {
  const head = el('div', { class: 'step-head' });
  head.append(
    el('div', { class: 'eyebrow' }, 'Schritt 7 von 7'),
    el('h2', {}, 'Fotos, Unterschriften & Protokoll'),
    el(
      'p',
      {},
      'Übersichtsfotos ergänzen, unterschreiben – und das fertige Protokoll als PDF erzeugen.',
    ),
  );
  container.append(head);

  const fotoKarte = el('div', { class: 'card' });
  const fotoTitel = el('h3', {}, 'Übersichtsfotos ');
  fotoTitel.append(el('span', { class: 'sub' }, 'erscheinen im Fotoanhang des Protokolls'));
  fotoKarte.append(fotoTitel, fotoRow(ctx, ctx.p.data.fotosAllgemein, { captions: true }));
  container.append(fotoKarte);

  const sigKarte = el('div', { class: 'card' });
  const sigTitel = el('h3', {}, 'Unterschriften ');
  sigTitel.append(el('span', { class: 'sub' }, 'mit dem Finger direkt auf dem Bildschirm'));
  sigKarte.append(sigTitel);
  for (const s of ctx.p.data.sigs) sigKarte.append(sigPad(ctx, s));
  container.append(sigKarte);

  const abschlussKarte = el('div', { class: 'card' });
  abschlussKarte.append(el('h3', {}, 'Protokoll erzeugen'));
  abschlussKarte.append(
    el(
      'p',
      { style: 'margin:0 0 14px;color:var(--ink-soft);font-size:14px' },
      'Es werden nur tatsächlich erfasste Positionen gedruckt. Im Druckdialog „Als PDF sichern“ wählen.',
    ),
  );

  const druck = el(
    'button',
    { class: 'btn btn-primary', type: 'button', style: 'width:100%' },
    'Protokoll ansehen & als PDF speichern',
  );
  druck.addEventListener('click', () => druckeProtokoll(ctx));
  abschlussKarte.append(druck);

  const fehler = el('div', {
    class: 'form-error',
    role: 'alert',
    style: 'display:none;margin-top:10px',
  });

  if (!ctx.p.readonly) {
    const abschliessen = el(
      'button',
      { class: 'btn', type: 'button', style: 'width:100%;margin-top:10px' },
      'Protokoll abschließen (danach unveränderlich)',
    );
    abschliessen.addEventListener('click', async () => {
      if (!confirm('Protokoll wirklich abschließen? Es kann danach nicht mehr bearbeitet werden.'))
        return;
      abschliessen.disabled = true;
      try {
        await speichernJetzt(ctx.p);
        await api.abschliessen(ctx.p.id);
        ctx.p.status = 'abgeschlossen';
        ctx.p.readonly = true;
        ctx.rerender();
        ctx.recalc();
      } catch (err) {
        fehler.textContent = err instanceof ApiError ? err.message : 'Abschluss fehlgeschlagen.';
        fehler.style.display = 'block';
        abschliessen.disabled = false;
      }
    });
    abschlussKarte.append(abschliessen);
  } else if (ctx.user.rolle !== 'wertermittler') {
    const wieder = el(
      'button',
      { class: 'btn', type: 'button', style: 'width:100%;margin-top:10px' },
      'Protokoll wiedereröffnen',
    );
    wieder.addEventListener('click', async () => {
      wieder.disabled = true;
      try {
        await api.wiedereroeffnen(ctx.p.id);
        ctx.p.status = 'entwurf';
        ctx.p.readonly = false;
        ctx.rerender();
        ctx.recalc();
      } catch (err) {
        fehler.textContent =
          err instanceof ApiError ? err.message : 'Wiedereröffnen fehlgeschlagen.';
        fehler.style.display = 'block';
        wieder.disabled = false;
      }
    });
    abschlussKarte.append(wieder);
  }

  abschlussKarte.append(fehler);
  container.append(abschlussKarte);
}
